import { Scale } from "./scale";
import { ScaleRange } from "./scale-range";

export class ScaleResult
{
	private _scale:Scale;
	private _score:number;
	private _range:ScaleRange;
	
	constructor() {
		this.score = 0;
	}
	
	public get scale() : Scale {
		return this._scale;
	}
	
	public set scale(v : Scale) {
		this._scale = v;
	}
	
	
	public get score() : number {
		return this._score;
	}

	public getScoreForDisplay() : string {
		// @see https://stackoverflow.com/a/5623195
		return this._score.toFixed(2).replace(/[.,]00$/, "");
	}

	public get scorePercentage() : number {
		let score = 0;
		if (this.scale && this.score) {
			score = this.scale.getPercentageForScore(this.score);
		}
		return score;
	}
	
	
	public set score(v : number) {
		this._score = v;
	}
	
	public get range() : ScaleRange {
		return this._range;
	}
	
	public set range(v : ScaleRange) {
		this._range = v;
	}

	public getRangeDisplayName() {
		if (this._range) {
			return this._range.displayName;
		}
		return "";
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/scale-result.ts